import { request } from '@/shared/api/request'

export const getAffairForEmployer = (id) =>
    request({
        url: `contract/persCard/getCard?reqId=${id}`,
        method: 'GET'
    })
